import React from 'react';
import PropTypes from 'prop-types';

export class Modal extends React.PureComponent {
  render() {
    if (this.props.isModalOpen) {
      return (
        <div className={`modal-container ${this.props.className}`}>
          <div className="modal-content">
            {this.props.children}
          </div>
        </div>
      );
    }

    return null;
  }
}

Modal.propTypes = {
  isModalOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Modal.defaultProps = {
  isModalOpen: false,
  className: '',
};
